/**
 * @author Junaid Atari <mj.atari@gmail.com>
 * @see https://github.com/blacksmoke26/dawn-of-man-generator
 * @since 2020-08-29
 */

export const MAP_SIZE_MIN: number = 1;

export const MAP_SIZE_MAX: number = 12;

export const MAP_SIZE_DEFAULT: number = 4;

